const path = require('path');
const {
  CORE_SUPPORTED_LOCALES,
  CORE_DEFAULT_LOCALE,
  CORE_FALLBACK_LOCALE,
} = require('../../libs/common/i18n/src/core/locales');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    locales: [...CORE_SUPPORTED_LOCALES],
    defaultLocale: CORE_DEFAULT_LOCALE,
    localeDetection: false,
  },
  ns: [
    'accounts',
    'business',
    'common',
    'home',
    'layout',
    'manage',
    'store',
    'subscription',
    'wearables',
    'worldmodel',
  ],
  partialBundledLanguages: true,
  supportedLngs: [...CORE_SUPPORTED_LOCALES],
  fallbackLng: CORE_FALLBACK_LOCALE,
  returnEmptyString: false,
  serializeConfig: false,
  localePath: path.resolve('./public/locales'),
  reloadOnPrerender: process.env.NEXT_PUBLIC_STAGE === 'LOC',
};
